(function () {
  function findVariant(variants, values) {
    return variants.find(function (v) {
      return values.every(function (val, i) {
        return v.options[i] === val;
      });
    });
  }

  function getItemRow(line) {
    return document.getElementById('CartDrawer-Item-' + line) || document.getElementById('CartItem-' + line);
  }

  function getErrorWrap(line) {
    return document.getElementById('CartDrawer-LineItemError-' + line) || document.getElementById('Line-item-error-' + line);
  }

  function getQuantityInput(line) {
    return document.getElementById('Drawer-quantity-' + line) || document.getElementById('Quantity-' + line);
  }

  function setLineLoading(line, isLoading) {
    var row = getItemRow(line);
    if (!row) return;
    var overlays = row.querySelectorAll('.loading-overlay');
    for (var i = 0; i < overlays.length; i++) {
      overlays[i].classList.toggle('hidden', !isLoading);
    }
    var selects = row.querySelectorAll('.cart-variant-select');
    for (var j = 0; j < selects.length; j++) {
      selects[j].disabled = isLoading;
    }
  }

  function showLineError(line, message) {
    var wrap = getErrorWrap(line);
    if (!wrap) return;
    var target = wrap.querySelector('small') || wrap;
    target.textContent = message;
  }

  function clearLineError(line) {
    showLineError(line, '');
  }

  function refreshCartUI() {
    return fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var selectors = ['#CartDrawer .drawer__inner', '#main-cart-items', '#main-cart-footer'];
        selectors.forEach(function (sel) {
          var newEl = parsed.querySelector(sel);
          var currentEl = document.querySelector(sel);
          if (newEl && currentEl) {
            currentEl.innerHTML = newEl.innerHTML;
          }
        });
        var newDrawerEl = parsed.querySelector('cart-drawer');
        var currentDrawerEl = document.querySelector('cart-drawer');
        if (newDrawerEl && currentDrawerEl) {
          currentDrawerEl.classList.toggle('is-empty', newDrawerEl.classList.contains('is-empty'));
        }
        var newCartItemsEl = parsed.querySelector('cart-items');
        var currentCartItemsEl = document.querySelector('cart-items');
        if (newCartItemsEl && currentCartItemsEl) {
          currentCartItemsEl.classList.toggle('is-empty', newCartItemsEl.classList.contains('is-empty'));
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  function handleVariantChange(container) {
    var line = container.getAttribute('data-line');
    var lineKey = container.getAttribute('data-line-key');
    var currentVariantId = container.getAttribute('data-current-variant');
    var variants;
    try {
      variants = JSON.parse(container.getAttribute('data-variants'));
    } catch (e) {
      return;
    }

    var selects = Array.prototype.slice.call(container.querySelectorAll('.cart-variant-select'));
    var values = selects.map(function (s) { return s.value; });
    var match = findVariant(variants, values);

    if (!match) {
      showLineError(line, "Cette combinaison n'est pas disponible.");
      return;
    }
    if (String(match.id) === String(currentVariantId)) {
      clearLineError(line);
      return;
    }
    if (!match.available) {
      showLineError(line, 'Cette variante est en rupture de stock.');
      return;
    }

    clearLineError(line);
    setLineLoading(line, true);

    var qtyInput = getQuantityInput(line);
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: match.id, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (addResult) {
        if (addResult && addResult.status) {
          throw new Error(addResult.description || 'add_failed');
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var oldLineIndex = -1;
        cart.items.forEach(function (it, idx) {
          if (it.key === lineKey) {
            oldLineIndex = idx + 1;
          }
        });
        if (oldLineIndex === -1) {
          return Promise.resolve();
        }
        return fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: oldLineIndex, quantity: 0 })
        });
      })
      .then(function () {
        return refreshCartUI();
      })
      .catch(function () {
        showLineError(line, (window.cartStrings && window.cartStrings.error) || 'Une erreur est survenue, merci de reessayer.');
        setLineLoading(line, false);
      });
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.cart-variant-select');
    if (!select) return;
    var container = select.closest('.cart-variant-selectors');
    if (!container) return;
    handleVariantChange(container);
  });
})();
